import type { FaireProductEntity } from "../../entity_types/product";

export const p_c6ykvmgk7s: FaireProductEntity = {
  token: "p_c6ykvmgk7s",
  type: "product",
  name: "Torrone al Pistacchio – Soft Pistachio Nougat Bar (200g)",
  brandToken: "b_6cjsp5frk5",
  brandName: "Alto Imports Company",
  imageUrl:
    "https://cdn.faire.com/fastly/e6fd9f03abb4a769721723d5dfa8688eb168fbae3a214560605b14de5d99cbff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd043af5e802e1b5ca04bcb72a218f5762d941b965e3a482e987982ed5bc9bb1.jpeg",
  ],
  priceDollars: 15.94,
  description:
    "Indulge in one of Italy’s most beloved traditional sweets. This Torrone al Pistacchio is crafted in Sulmona by the historic Di Carlo family confectionery, established in 1833. Made with whole premium pistachios, Italian honey, egg whites, and sugar, this torrone has a soft, tender texture (tenero bianco) and a rich pistachio flavor in every bite.\n\nEach 200g bar is elegantly packaged, making it ideal for:\n• Holiday gifting\n• Gourmet retail displays\n• Italian specialty assortments\n• Stocking stuffers\n• Dessert platters and gift baskets\n\nThis artisan nougat follows classic Abruzzese tradition, offering retailers a high-quality, visually appealing product that customers love during the winter and holiday season.",
  tags: [],
  msrpDollars: 31.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:16.406Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
